import { Injectable } from '@angular/core';
import { toErrorWithMessage } from '@thehubz/shared/model';
import { MessageType, NotificationService } from '../services/notification.service';

@Injectable({ providedIn: 'root' })
export class ClientNotificationHandlerService {
  private static MatchModelRegex = /on model "(\w+)"/;

  constructor(private readonly notificationsService: NotificationService) {}

  errorNotification(err: unknown) {
    console.error(err);
    const error = toErrorWithMessage(err);
    return this.notificationsService.addNotification({
      type: 'failure',
      title: error.statusText !== 'OK' ? error.statusText : $localize`Error`,
      message: this.patchErrorMessage(error.message),
    });
  }

  errorStringNotification(err: string, title?: string) {
    return this.notificationsService.addNotification({
      type: 'failure',
      title,
      message: this.patchErrorMessage(err),
    });
  }

  successNotification(message: string, type?: MessageType, duration?: number) {
    return this.notificationsService.addNotification({
      type: type ? type : 'success',
      message: message ? message : '',
      duration: duration ? duration : undefined,
    });
  }

  private patchErrorMessage(msg?: string) {
    if (typeof msg?.startsWith === 'function' && msg?.startsWith('No document found for query')) {
      const match = msg.match(ClientNotificationHandlerService.MatchModelRegex);
      return match ? `The referenced ${match[1]} can not be found in database` : 'A referenced object can not be found in database';
    }
    return msg || $localize`Something went wrong`;
  }
}
